import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";

export const Step5UpgradeUser = () => {
    const { baseProps, currentStep } = useUpsellWidgetContainer();

    if (currentStep !== UpsellPanelSteps.Step5UpgradeUser) {
        return null;
    }
    return <div className="step5">
        <p>{baseProps.upgradeCTAText}</p>

        <div className="row">
            <div className="col col-xs-12">
                <a className="btn btn-primary my-1 btn-brand-style-with-pad-sm" href={baseProps.upgradeURL}>{ baseProps.upgradeCTA }</a>
            </div>
        </div>
    </div>;
};